import { render, staticRenderFns } from "./SkeletonContent.vue?vue&type=template&id=36971d54&"
import script from "./SkeletonContent.vue?vue&type=script&lang=js&"
export * from "./SkeletonContent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonContent.vue?vue&type=style&index=0&id=36971d54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports